export default __webpack_public_path__ + "assets/images/icon-attachment.7fe80512ff98edb3e3cc5014c0269cf0.svg";